import React from 'react';
import styled from 'styled-components';
import { palette } from '../../system/styles/styles';
import imgMain from '../../system/access/images/company/Normal.png';
import SteppsImport from '../components/company/Steps';
import ContainerCompany from '../components/company/containerCompany';
import { useSelector } from 'react-redux';
import ContainerEmail from '../components/company/containerEmail';
import ContainerUser from '../components/company/containerUser';
const FormMain = styled.main`
  display: grid;
  grid-template-columns: 20% calc(80% - 20px);
  justify-content: center;
  align-items: center;
  background-color: ${palette.colorBackground};
  padding: 10px;
  > section {
    width: 100%;
    height: 80vh;
  }
  .leftContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 50%;
      margin: 0 auto 10px auto;
      object-position: center;
      object-fit: cover;
    }
  }
`;

const Companies = () => {
  const [steps] = React.useState([
    { title: 'GeneralStep', idx: 0 },
    { title: 'MailingStep', idx: 1 },
    { title: 'UsersStep', idx: 2 },
  ]);
  const [countStep, setCountSteps] = React.useState(0);
  const { company } = useSelector((state) => state);
  const handleStep = async (number) => {
    setCountSteps(number);
  };

  const getOptionView = () => {
    switch (countStep) {
      case 1:
        return <ContainerEmail />;
      case 2:
        return <ContainerUser />;
      case 0:
      default:
        return <ContainerCompany company={company} />;
    }
  };

  return (
    <FormMain>
      <section className="leftContainer">
        <img alt="Sin Logo" src={imgMain} />
        <SteppsImport activeStep={countStep} handleStep={handleStep} Steps={steps} />
      </section>
      {getOptionView()}
    </FormMain>
  );
};

export default Companies;
